import React from 'react';

import Text from '@components/common/Text/Text';
import { formatFullDateToWord } from '@services/utils/DateService';
import { getCategoryIconSrc, isSupportedCategory } from '@services/utils/UserService';

import css from './DisabledInput.module.scss';

type DisabledInputProps = {
    type: string;
    children: React.ReactNode;
    category?: string;
    hideImage?: boolean;
};

const DisabledInput = ({ type, category, children }: DisabledInputProps) => {
    return (
        <div className={css.disabled}>
            {type === 'date' && (
                <div className={css.disabled__date}>
                    <img src="/front-static/icons/pot/categories/DATE.svg" alt={'calendar'} />
                    <Text variant={'caption_02'} color={'txt-primary'}>
                        {formatFullDateToWord(children)}
                    </Text>
                </div>
            )}
            {type === 'category' && (
                <div className={css.disabled__category}>
                    {isSupportedCategory(category) && <img src={getCategoryIconSrc(category)} alt={category} />}
                    <Text variant={'caption_02'} color={'txt-primary'}>
                        {children}
                    </Text>
                </div>
            )}
        </div>
    );
};

export default DisabledInput;
